import React from 'react';
import DataTable from 'react-data-table-component';
import { Alert }  from 'reactstrap';
import { TableSearchForm } from '../Common/TableSearchForm';
import { OperatorActionsButton } from './ActionsButton';

export function OperatorsList(props) {
    const columns = [
        {
            name: 'Full Name',
            selector: 'firstName',
            sortable: true,
            ignoreRowClick: true,
            cell: (row) => {
                return <span>{row.firstName} {row.surname}</span>
            }
        },
        {
            name: '',
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            cell: (row) => {
                return (
                    <OperatorActionsButton 
                        operator={row} 
                        handleEdit={props.handleEdit} 
                        handleDelete={props.handleDelete}
                    />
                );
            }
        }
    ];

    const hasAny = props.items && props.items.length > 0;

    return (
        <>
            <TableSearchForm handleSearch={props.handleSearch} />
            {
                hasAny ? (
                    <DataTable
                        columns={columns}
                        data={props.items}
                        defaultSortField="firstName"
                        pagination
                        highlightOnHover
                        noHeader
                        paginationPerPage={50}
                        paginationRowsPerPageOptions={[10, 25, 50, 100]}
                    />
                ) : <Alert color="warning">No Operators were found</Alert>
            }
        </>
    );
}

